import React, { useState } from 'react';
import VideoModal from "./VideoModal";

const SolutionSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <section className="py-24 px-6 bg-white" id="solution">
        <div className="max-w-[960px] mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-extrabold mb-6 text-[#050B15]">Miporis is your internal control assurance layer.</h2>
          </div>
          <div className="grid md:grid-cols-2 gap-12 mb-16">
            <div className="space-y-6">
              <div className="flex gap-4 group">
                <div className="flex-shrink-0 w-12 h-12 bg-[#22C55E]/10 rounded-lg flex items-center justify-center relative group-hover:scale-110 transition-transform">
                  <span className="material-symbols-outlined text-[#22C55E] text-2xl">folder_managed</span>
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#22C55E] text-white rounded-full flex items-center justify-center text-xs font-bold">1</span>
                </div>
                <div>
                  <h4 className="font-bold text-[#050B15] mb-1">Centralise</h4>
                  <p className="text-sm text-gray-600">Gather all disparate control data into one single source of truth.</p>
                </div>
              </div>
              <div className="flex gap-4 group">
                <div className="flex-shrink-0 w-12 h-12 bg-[#FFD100]/10 rounded-lg flex items-center justify-center relative group-hover:scale-110 transition-transform">
                  <span className="material-symbols-outlined text-[#FFD100] text-2xl">assessment</span>
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#FFD100] text-white rounded-full flex items-center justify-center text-xs font-bold">2</span>
                </div>
                <div>
                  <h4 className="font-bold text-[#050B15] mb-1">Assess</h4>
                  <p className="text-sm text-gray-600">Apply rigorous standards to determine if controls are genuinely effective.</p>
                </div>
              </div>
              <div className="flex gap-4 group">
                <div className="flex-shrink-0 w-12 h-12 bg-[#F87171]/10 rounded-lg flex items-center justify-center relative group-hover:scale-110 transition-transform">
                  <span className="material-symbols-outlined text-[#F87171] text-2xl">warning</span>
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#F87171] text-white rounded-full flex items-center justify-center text-xs font-bold">3</span>
                </div>
                <div>
                  <h4 className="font-bold text-[#050B15] mb-1">Identify gaps</h4>
                  <p className="text-sm text-gray-600">Surface control weaknesses before the audit process begins.</p>
                </div>
              </div>
              <div className="flex gap-4 group">
                <div className="flex-shrink-0 w-12 h-12 bg-[#0077C8]/10 rounded-lg flex items-center justify-center relative group-hover:scale-110 transition-transform">
                  <span className="material-symbols-outlined text-[#0077C8] text-2xl">description</span>
                  <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#0077C8] text-white rounded-full flex items-center justify-center text-xs font-bold">4</span>
                </div>
                <div>
                  <h4 className="font-bold text-[#050B15] mb-1">Produce summaries</h4>
                  <p className="text-sm text-gray-600">Instantly generate high-level reporting for the Board and regulators.</p>
                </div>
              </div>
            </div>
            <div className="bg-gray-100 rounded-xl p-8 flex flex-col justify-center border-l-8 border-[#0077C8]">
              <div className="flex items-center gap-3 mb-4">
                <span className="material-symbols-outlined text-[#0077C8] text-3xl">bolt</span>
                <h4 className="text-xl font-extrabold text-[#050B15]">Zero Friction Implementation</h4>
              </div>
              <ul className="space-y-4">
                <li className="flex items-center gap-3 text-sm font-bold text-gray-700">
                  <span className="material-symbols-outlined text-[#0077C8]">remove_done</span> No process redesign.
                </li>
                <li className="flex items-center gap-3 text-sm font-bold text-gray-700">
                  <span className="material-symbols-outlined text-[#0077C8]">person_remove</span> No headcount increase.
                </li>
                <li className="flex items-center gap-3 text-sm font-bold text-gray-700">
                  <span className="material-symbols-outlined text-[#0077C8]">swap_horiz</span> No rip-and-replace.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <VideoModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        videoSrc={`${process.env.PUBLIC_URL || ''}/MIPORIS V_FINAL.mp4`}
      />
    </>
  );
};

export default SolutionSection;
